import { InputHTMLAttributes, forwardRef } from 'react';
import { FiSearch } from 'react-icons/fi';
import { MdOutlineClose } from 'react-icons/md';
import { cn } from '../../lib/utils';

interface SearchTextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  cancelSearch?: () => void;
  wrapperClassName?: string;
}

export const SearchTextInput = forwardRef<HTMLInputElement, SearchTextInputProps>(
  (
    { className, wrapperClassName, value, cancelSearch, ...props },
    ref
  ) => {
    return (
      <div className={cn('relative flex items-center w-full', wrapperClassName)}>
        <FiSearch
          className="absolute left-3 text-slate-400 pointer-events-none"
          size={16}
        />
        <input
          ref={ref}
          type="text"
          value={value}
          className={cn(
            'flex h-10 w-full rounded-xl border border-slate-200 bg-white pl-10 pr-10 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-4 focus:ring-teal-primary/20 focus:border-teal-primary transition-all duration-200 shadow-sm',
            className
          )}
          {...props}
        />
        {value && cancelSearch && (
          <button
            type="button"
            className="absolute right-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full p-1.5 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-primary/20"
            title="Clear search"
            onClick={cancelSearch}
          >
            <MdOutlineClose size={16} />
          </button>
        )}
      </div>
    );
  }
);

SearchTextInput.displayName = 'SearchTextInput';
